import { Input as AntInput } from 'antd';
import { Row, Column } from '@bancobarigui/barihaus';
import { Form, Select, Text } from '@bancobarigui/barihaus';
import { MaskedInput } from '@/shared/components/MaskedInput';

export function ScheduleForm() {
  return (
    <>
      <Text className="text-base mb-4">
        Defina a data e horário do agendamento. Caso queira, você também poderá adicionar uma nota
        de agendamento.
      </Text>

      <Row gutter={[16, 16]}>
        <Column span={24}>
          <Form.Item
            name="scheduleDate"
            label="Agendamento"
            rules={[{ required: true, message: 'Campo obrigatório' }]}
          >
            <MaskedInput placeholder="DD/MM/AAAA" mask="00/00/0000" />
          </Form.Item>
        </Column>

        <Column span={24}>
          <Form.Item
            name="timeSlot"
            label="Horário"
            rules={[{ required: true, message: 'Campo obrigatório' }]}
          >
            <Select
              placeholder="Selecione o horário"
              options={[
                { value: '1', label: '8h às 12h', disabled: false },
                { value: '2', label: '12h às 18h', disabled: false },
                { value: '3', label: '18h às 22h', disabled: false },
              ]}
            />
          </Form.Item>
        </Column>

        <Column span={24}>
          <Form.Item name="notes" label="Nota">
            <AntInput.TextArea
              placeholder="Adicione uma nota (opcional)"
              rows={4}
              maxLength={500}
            />
          </Form.Item>
        </Column>
      </Row>
    </>
  );
}
